import { useEffect } from "react";

// Component that handles token redirection without showing any UI
const TokenRedirect = () => {
  useEffect(() => {
    const currentUrl = window.location.href;
    const origin = window.location.origin;
    
    console.log("TokenRedirect: Processing URL", currentUrl);
    
    // Extract token using regex
    const tokenRegex = /access_token=([^&]+)/;
    const typeRegex = /type=([^&]+)/;
    const match = currentUrl.match(tokenRegex);
    const typeMatch = currentUrl.match(typeRegex);
    
    if (match && typeMatch && typeMatch[1] === 'recovery') {
      // This is a password reset link
      const token = match[1];
      const redirectUrl = `${origin}/#/reset-password?access_token=${token}&type=recovery`;
      console.log("TokenRedirect: Redirecting to reset password page");
      window.location.replace(redirectUrl);
    } else {
      // Not a valid reset link, go to login
      console.log("TokenRedirect: Invalid reset link, redirecting to login");
      window.location.replace(`${origin}/#/login`);
    }
  }, []);
  
  // Return null - no UI will be rendered
  return null;
};

export default TokenRedirect;